<template>
    <div class="debug-page">

        <div class="peribox">
            <div class="perititle">
                <div>Query</div>
            </div>
            <div v-text="query" style="white-space: pre-wrap; font-family: monospace"></div>
        </div>
        <div class="peribox" v-if="remedy">
            <div class="perititle">
                <div>Remedy</div>
            </div>
            <div>Command: {{ remedy }}</div>
            <btn :click="applyRemedy">Apply Remedy</btn>
        </div>
        <div class="peribox">
            <div class="perititle">
                <div>Failed Rows</div>
                <div class="periicons">
                    <i class="far fa-sync-alt" @click="refresh"></i>
                </div>
            </div>
            <i class="fas fa-spinner fa-pulse" v-if="loading"></i>
            <template v-else>
                <table class="peritable">
                    <tbody>
                    <tr>
                        <th v-for="c in columns">{{ c }}</th>
                    </tr>
                    <tr v-for="row in rows">
                        <td v-for="c in columns">{{ row ? row[c] : '' }}</td>
                    </tr>
                    </tbody>
                </table>

                <btn :click="addException" style="margin-top: 10px;">Add an exception for 14 days</btn>
            </template>
        </div>

        <div class="peribox">
            <div class="perititle">
                <div>Exceptions</div>
            </div>
            <i class="fas fa-spinner fa-pulse" v-if="loading"></i>
            <template v-else>
                <table class="peritable" v-if="exceptions.rows.length > 0">
                    <tbody>
                    <tr>
                        <th v-for="c in exceptions.columns">{{ c }}</th>
                    </tr>
                    <tr v-for="row in exceptions.rows">
                        <td v-for="c in exceptions.columns">{{ row ? row[c] : '' }}</td>
                    </tr>
                    </tbody>
                </table>
                <btn :click="clearExceptions" style="margin-top: 10px;">Clear all</btn>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'data'
    ],
    data() {
        return {
            rows: [],
            columns: [],
            exceptions: {
                rows: [],
                columns: []
            },
            query: '',
            remedy: '',
            loading: false,
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            axios.get(url(`integrity-checks/${this.data.class_name}/data`))
                .then(response => {
                    this.rows = response.data.rows;
                    this.columns = response.data.columns;
                    this.remedy = response.data.remedy;
                    this.exceptions = response.data.exceptions;
                    this.loading = false;
                });
            axios.get(url(`integrity-checks/${this.data.class_name}/query`))
                .then(response => {
                    this.query = response.data;
                });
        },
        applyRemedy() {
            return axios.post(url(`integrity-checks/${this.data.class_name}/apply-remedy`))
                .then(response => this.refresh());
        },
        addException() {
            return this.$prompt('', 'Reason', {
                    inputType: 'textarea',
                    inputValue: '',
                    closeOnClickModal: false
                }).then(({ value }) => {
                    return axios.post(url(`integrity-checks/${this.data.class_name}/add-exception`), {
                        reason: value
                    }).then(response => {
                        this.refresh();
                    });
                })
        },
        clearExceptions() {
            return axios.post(url(`integrity-checks/${this.data.class_name}/clear-exception`))
                .then(response => {
                    this.refresh();
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>